import { useTranslation } from 'react-i18next'

import {
  AddCircleOutlineIcon,
  Button,
  EditIcon,
  TableColumnsColumnProps,
  Text,
} from '@mercai/clever'

import { DrawerSupplyPaymentForm, TableSupplyPayments } from './components'

import { TabPaymentsProps } from './tab-payments.type'

import { SupplyPaymentProps, SupplyPaymentTypeEnum } from '@/types'

import { QUERIES_ADMIN } from '@/services'
import { useQueryClient } from '@tanstack/react-query'
import styles from './tab-payments.module.css'

export const TabPayments = ({
  supplyOrder,
  isLoading,
  params,
  setParams,
}: TabPaymentsProps) => {
  const { t } = useTranslation('screenSupplyOrderDetail')

  const queryClient = useQueryClient()

  const onChangeParams = (newParams: typeof params) => {
    setParams({ ...params, ...newParams })
  }

  const onCloseForms = () => {
    setParams({ ...params, openForm: '' })
  }

  const actions: TableColumnsColumnProps<SupplyPaymentProps> = {
    title: '',
    key: 'actions',
    width: '4.5rem',
    render: ({ record }) => {
      const isDisabled =
        !record?.type || record?.type === SupplyPaymentTypeEnum.cost_of_goods
      return (
        <Button
          variant="secondary"
          size="small"
          model="square"
          disabled={isDisabled}
          onClick={
            isDisabled
              ? undefined
              : () => onChangeParams({ openForm: record?.uuid || '' })
          }
        >
          <EditIcon />
        </Button>
      )
    },
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <Text className={styles.title} variant="title-medium">
            {t('tabPaymentsTitle')}
          </Text>
        </div>

        <Button
          variant="ghost"
          className={styles['add-button']}
          onClick={() => onChangeParams({ openForm: 'true' })}
        >
          {t('tabPaymentsAdditionalPaymentButton')}
          <AddCircleOutlineIcon />
        </Button>
      </div>
      <TableSupplyPayments
        data={supplyOrder?.payments || []}
        isLoading={isLoading}
        actions={actions}
      />
      <DrawerSupplyPaymentForm
        isOpen={!!(params.openForm && params.openForm !== '')}
        onClose={onCloseForms}
        supplyOrderUuid={supplyOrder?.uuid}
        supplierUuid={supplyOrder?.supplier?.uuid || supplyOrder?.supplierUuid}
        uuid={params.openForm !== 'true' ? params.openForm : undefined}
        onSuccess={() => {
          queryClient.invalidateQueries({
            queryKey: [QUERIES_ADMIN.SUPPLIER_ORDER.module, supplyOrder?.uuid],
          })
        }}
      />
    </div>
  )
}
